"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacing = void 0;
var UNIT = 8;
var Base = {
    /** Base = 8 */
    unit: UNIT,
    none: 0,
    /** Base / 2 = 4 */
    extraSmall: UNIT / 2,
    /** Base = 8 */
    small: UNIT,
    /** Base * 2 = 16 */
    medium: UNIT * 2,
    /** Base * 4 = 32 */
    large: UNIT * 4,
    /** Base * 5 = 40 */
    extraLarge: UNIT * 5,
};
exports.Spacing = __assign(__assign({}, Base), { 
    /**
     * The standard or "normal" spacing.
     * A component might have a different "normal" spacing.
     * This is just the generic default spacing.
     */
    normal: Base.small });
